import * as actions from '@xmatters/redux/actions/conferences';

import ConferenceEvent from './ConferenceEvent';

export const defaultState = {
  eventsLoading: true,
  participantsLoading: true,
  error: false,
  conferenceParticipants: [],
  conferenceEvents: [],
  participantsSpeaking: [],
};

export default function conferencesReducer(state = defaultState, action) {
  switch (action.type) {
    case actions.LOAD_EVENTS:
      return {
        ...state,
        eventsLoading: true,
      };
    case actions.SORT_CONFERENCE_EVENTS_SUCCESS:
    case actions.LOAD_EVENTS_SUCCESS:
      return {
        ...state,
        conferenceEvents: action.payload.data.map(
          event => new ConferenceEvent(event),
        ),
        eventsLoading: false,
      };
    case actions.SORT_CONFERENCE_EVENTS_FAIL:
    case actions.LOAD_EVENTS_FAIL:
      return {
        ...state,
        conferenceEvents: null,
        error: true,
      };
    case actions.SET_SPEAKING_LIST:
      return {
        ...state,
        participantsSpeaking: action.payload,
      };
    default:
      return state;
  }
}
